import React from "react";
import { Link } from "react-router-dom";
import { Clock, GraduationCap, ArrowUpRight } from "lucide-react";
import { asset } from "@/lib/api";

export default function CourseCard({ c, featured = false }) {
  return (
    <Link
      to={`/learn/${c.id}`}
      data-testid={`course-card-${c.id}`}
      className={
        "group relative flex flex-col overflow-hidden rounded-lg border border-border bg-card transition-all hover:-translate-y-1 hover:shadow-xl " +
        (featured ? "md:col-span-2" : "")
      }
    >
      <div className={"relative overflow-hidden " + (featured ? "aspect-[16/9]" : "aspect-[4/3]")}>
        <img
          src={asset(c.cover)}
          alt={c.title}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

        <div className="absolute top-4 left-4 flex items-center gap-2">
          {c.new && <span className="rounded-full bg-accent text-accent-foreground px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest">New</span>}
          {c.featured && <span className="rounded-full border border-white/40 text-white px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest backdrop-blur">Featured</span>}
        </div>

        <div className="absolute bottom-4 left-4 right-4 text-white">
          <div className="text-[10px] uppercase tracking-[0.24em] opacity-80">{c.track}</div>
          <div className="font-display text-2xl md:text-3xl leading-tight mt-1">{c.title}</div>
        </div>
      </div>

      <div className="p-5 flex flex-col gap-3">
        <p className="text-sm text-muted-foreground line-clamp-2">{c.subtitle}</p>
        <div className="flex items-center justify-between text-xs text-muted-foreground pt-2 border-t border-border">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1"><GraduationCap className="h-3.5 w-3.5" /> {c.level}</span>
            <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {c.duration}</span>
            <span>·  {c.lessons_count} lessons</span>
          </div>
          <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
        </div>
      </div>
    </Link>
  );
}
